export const MuiIconButton = (palette) => ({
  defaultProps: {
    disableRipple: true,
  },
  styleOverrides: {
    root: {
      color: palette.text.primary,
      '&:hover': {
        color: palette.primary.main,
      },
      '&:focus': {
        outline: `1px solid ${palette.primary.main}`,
      },
    },
  },
});
